import { InfoCircle } from '@shared/icons';
import { Tooltip } from '../../../../../Tooltip/Tooltip';

type CellTooltipProps = {
  children: React.ReactNode;
};

function CellTooltip({ children }: CellTooltipProps) {
  return (
    <Tooltip className="flex items-center" trigger={<InfoCircle size="small" />}>
      {children}
    </Tooltip>
  );
}

export { CellTooltip };
